import React from 'react';
import { stats } from '~/marketing/marketingData';

/* Every marketing figure renders through this, reading one data module.
   Placeholder figures are hatched and tagged on purpose — conspicuous, so
   none can pass as measured. Swapping in a real figure is a data edit. */
const HATCH = {
  color: 'var(--text-strong)',
  backgroundImage: 'repeating-linear-gradient(135deg,rgba(255,255,255,.10) 0 2px,transparent 2px 7px)',
  boxShadow: 'inset 0 0 0 1px rgba(255,255,255,.22)', borderRadius: 4, padding: '0 .22em',
};
const TAG = {
  fontSize: 10, letterSpacing: '.09em', textTransform: 'uppercase', color: 'var(--ink-200)',
  border: '1px dashed rgba(255,255,255,.28)', borderRadius: 3, padding: '2px 6px', whiteSpace: 'nowrap',
  backgroundImage: 'repeating-linear-gradient(135deg,rgba(255,255,255,.07) 0 2px,transparent 2px 7px)',
};

export function Stat({ id, mode = 'claim', claimSize = 'var(--fs-h3)', figureSize = 'var(--fs-num-lg)', note = true }) {
  const s = stats[id];
  if (!s) return null;
  const ph = s.status === 'placeholder';
  const valueStyle = ph ? HATCH : { color: 'var(--teal)' };
  return (
    <div style={{ display: 'grid', gap: 10 }}>
      {mode === 'claim' ? (
        <p style={{ fontFamily: 'var(--font-display)', fontWeight: 'var(--fw-semibold)', letterSpacing: 'var(--tr-display)', lineHeight: 1.24, color: 'var(--text-strong)', margin: 0, fontSize: claimSize }}>
          <span>{s.before}</span>
          {/* A figure never breaks across lines: "209 of" / "229" reads as two numbers. */}
          <span className="sp-mono" style={{ fontWeight: 'var(--fw-medium)', whiteSpace: 'nowrap', ...valueStyle }}>{s.value}</span>
          <span>{s.after}</span>
        </p>
      ) : (
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, flexWrap: 'wrap' }}>
          <span className="sp-mono" style={{ lineHeight: 1, fontWeight: 'var(--fw-medium)', fontSize: figureSize, ...valueStyle }}>{s.value}</span>
          <span style={{ fontSize: 'var(--fs-body-sm)', color: 'var(--text-body)' }}>{s.after}</span>
        </div>
      )}
      {note && (
        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
          <span className="sp-mono" style={TAG}>{ph ? 'Placeholder' : 'Measured'}</span>
          <span className="sp-mono" style={{ fontSize: 11, lineHeight: 1.5, color: 'var(--text-muted)', maxWidth: '62ch' }}>{s.note}</span>
        </div>
      )}
    </div>
  );
}
